export const publicKey = `-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCeNtKLeA4RI3GQgAINz+vICo1w
LlP8lp67FLv4B+WZ2E2Fuf6QXsj5hqEwhaUt5a5O8wL1ughoD/QI7zyTrgac5mJw
j8G+kxaYwg8UIgttxBHVwpSbA2jvLz3cHnWc8nrnSLxZe/uO8bO8kv4nJCFfaWYh
jXG300p1hUmbQjvT2wIDAQAB
-----END PUBLIC KEY-----`
